<template>
  <div>
    <div id="rare-list-page" class="rfp-comon-space-declaration"></div>
    <div class="rfp-rr-most-ratings-list-050-or header">
      <p
        v-if="!noDataFound && ratingsListOption != 'carousel list view'"
        class="rfp-rr-most-ratings-list-051-or rfp-header-menu"
      >
        <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
        <span v-if="ratingsListOption === 'Ratings load more'">
          <span class="rfp-rr-most-ratings-list-053">
            {{ items.length }}
          </span>
        </span>
        <span v-else>
          <span
            v-if="
              items.length > reviewPaginationCount && items.length > toPages * reviewPaginationCount
            "
            class="rfp-rr-most-ratings-list-052-or"
          >
            {{ toPages }}
          </span>
          <span v-else class="rfp-rr-most-ratings-list-053">
            <span v-if="totalNoOfApprovedReviewsPagiantions === currentPageNo">{{
              totalNoOfApprovedReviews
            }}</span>
            <span v-else>{{ currentPageNo * reviewPaginationCount }}</span>
          </span>
        </span>
        <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
      </p>
      <p v-else class="rfp-rr-most-ratings-list-051-or rfp-header-menu">
        <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
        <span class="rfp-rr-most-ratings-list-053">
          <span v-if="ratingsListOption != 'carousel list view'">0</span>
          <span v-else>
            <template v-if="totalNoOfApprovedReviews === 0">
              {{ currentPaginationPage }}
            </template>
            <template v-if="totalNoOfApprovedReviews != 0">
              {{ currentPaginationPage + 1 }}
            </template>
          </span>
        </span>
        <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
      </p>
      <div class="header-right">
        <span
          v-if="ratingsListOption != 'carousel list view'"
          class="rfp-rr-most-ratings-list-061-or"
          @click="filterSortEnableFunction()"
        >
          <li color="white bold" class="rfp-rr-most-ratings-list-062-or">
            <p class="rfp-rr-most-ratings-list-063-or rfp-desktop-view">
              {{ sortDisplayData }}<i class="arrow-down"></i>
            </p>
            <p class="rfp-rr-most-ratings-list-064-or rfp-mobile-view">
              {{ sortDisplayDatamobileView }}<i class="arrow-down"></i>
            </p>
          </li>
        </span>
        <template v-if="supportContent != ''">
          <span class="rfp-common-space"></span>
          <span
            class="rfp-rr-most-ratings-list-055-or rfp-button-radius"
            @click="supportContentEnableFunction()"
            >?</span
          >
        </template>
        <span class="rfp-common-space"></span>
        <span
          v-if="ratingsListOption != 'carousel list view'"
          class="rfp-rr-most-ratings-list-068-or rr-sort float-left"
        >
          <li color="white bold" class="rfp-rr-most-ratings-list-069-or" @click="hamburger()">
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
          </li>
        </span>
      </div>
      <ul
        v-if="filterSortEnable"
        class="rfp-rr-most-ratings-list-066-or rr-sort-content rating-sort rfp-sort-arrow_box"
        :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
      >
        <li
          v-for="(x, listIndex) in sortList"
          :key="listIndex"
          class="rfp-rr-most-ratings-list-067-or black bold"
          @click="sortReviews(x.Key, x.Value)"
        >
          {{ x.Value }}
        </li>
      </ul>
      <ul
        v-if="supportContentEnable"
        class="rfp-rr-most-ratings-list-058-or rr-sort-content rating-sort-sm rfp-support-arrow_box"
      >
        <li class="rfp-rr-most-ratings-list-059-or black">
          <i class="rfp-rr-most-ratings-list-060-or caret up-arrow"></i
          ><span v-html="supportContent"></span>
        </li>
      </ul>
    </div>
    <div v-if="filterDiv">
      <div class="rfp-comon-space-declaration"></div>
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <symbol id="rfp-ratings-checkmark" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-miterlimit="10"
            fill="none"
            d="M22.9 3.7l-15.2 16.6-6.6-7.1"
          ></path>
        </symbol>
      </svg>
      <div class="form-container">
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('one')"
        >
          <input
            v-model="rfpFilterOne"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ oneStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('two')"
        >
          <input
            v-model="rfpFilterTwo"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ twoStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('three')"
        >
          <input
            v-model="rfpFilterThree"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ threeStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('four')"
        >
          <input
            v-model="rfpFilterFour"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ fourStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('five')"
        >
          <input
            v-model="rfpFilterFive"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ fiveStarText }}
          </label>
        </div>
        <span
          v-if="
            (filterCounts >= 2 && stars.oneStar) ||
            (filterCounts >= 2 && stars.twoStar) ||
            (filterCounts >= 2 && stars.threeStar) ||
            (filterCounts >= 2 && stars.fourStar) ||
            (filterCounts >= 2 && stars.fiveStar) ||
            (filterCounts >= 2 && sort.hlr) ||
            (filterCounts >= 2 && sort.lhr) ||
            (filterCounts >= 2 && sort.mh) ||
            (filterCounts >= 2 && sort.mr)
          "
          class="rfp-ratings-clearAll_filter"
          @click="clearAllStars"
          >{{ clearAll }}</span
        >
      </div>
    </div>
    <div class="rfp-comon-space-declaration"></div>
    <div class="rfp-rr-most-ratings-list-095-or rr-all-review-container">
      <div v-if="ratingsListOption != 'carousel list view'">
        <div v-if="ratingsListOption != 'Ratings load more'">
          <div>
            <paginate
              ref="paginator"
              name="items"
              :list="items"
              :per="reviewPaginationCount"
              class="rfp-rr-most-ratings-list-096-or paginate-list"
            >
              <template v-for="(item, itemIndex) in paginated('items')">
                <div v-if="item.NickName != ''" :key="`item-${itemIndex}`">
                  <div
                    class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
                  >
                    <div
                      v-if="
                        showHideLocation ||
                        showLabelNickname ||
                        userTypeShowHide ||
                        showHideAgeRange
                      "
                      class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left"
                    >
                      <p
                        class="rfp-rr-most-ratings-list-099-or rr-user-name"
                        itemprop="author"
                        itemscope
                        itemtype="https://schema.org/Person"
                        :class="{ 'label-hide-show': !showLabelNickname }"
                      >
                        <span class="black bold" itemprop="name">{{ item.NickName }}</span>
                      </p>
                      <p
                        v-if="showHideLocation"
                        class="rfp-rr-most-ratings-list-100-or rr-user-location"
                      >
                        <span>{{ item.Location }}</span>
                      </p>
                      <p
                        v-if="userTypeShowHide || item.UserType != null"
                        class="rfp-rr-most-ratings-list-133-or rr-user-name"
                      >
                        {{ userTypeDesc }} :<span> {{ item.UserType }}</span>
                      </p>
                      <p
                        v-if="item.AgeRange && showHideAgeRange"
                        class="rfp-rr-most-ratings-list-102-or rr-user-age"
                      >
                        {{ ageLabel }} : <span class="bold"> {{ item.AgeRange }}</span>
                      </p>
                    </div>
                    <div
                      class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right"
                      :class="{
                        'rfp-rare-full-width-conntainer':
                          !showHideLocation &&
                          !showLabelNickname &&
                          !userTypeShowHide &&
                          !showHideAgeRange,
                      }"
                    >
                      <span
                        class="rfp-rr-most-ratings-list-104-or review-stars"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <vue-star-rating
                          :increment="starRatingIncrementValue"
                          :max-rating="starRatingMaxRatingValue"
                          :inactive-color="starRatingInactiveColor"
                          :active-color="starRatingActiveColor"
                          :star-size="starRatingStarSize"
                          :rating="item.OverallRating"
                          :read-only="true"
                          :show-rating="false"
                        >
                        </vue-star-rating>
                      </span>
                      <span
                        v-if="showCreatedAt"
                        class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                        >- {{ item.CreatedDate }}</span
                      >
                      <div
                        class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                      ></div>
                      <h3
                        v-if="showHideReviewTitle"
                        class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                      >
                        {{ item.ReviewTitle }}
                      </h3>
                      <p
                        v-if="showHideReviewContent"
                        class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                        v-html="item.ReviewContent"
                      ></p>
                      <div
                        v-if="showHideQualityRating"
                        class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                        :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                      >
                        <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">
                          {{ qualityOfProductLabel }}
                        </span>
                        <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer">
                          <span
                            class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                            :style="{ width: item.QualityRating * 20 + '%' }"
                          >
                          </span>
                        </span>
                        <span
                          class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold"
                        >
                          {{ item.QualityRating }}
                        </span>
                      </div>
                      <rfp-ratings-list-images
                        v-if="hasImages(item)"
                        :data="item.Images"
                        @openedmodal="(e) => openModal(e, item.Images)"
                      >
                      </rfp-ratings-list-images>
                      <div
                        v-if="showHideIsProductRecommended"
                        class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                      >
                        <div
                          class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                          itemprop="reviewBody"
                          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                        >
                          <p v-if="!item.IsProductRecommended" style="margin-right: 0px">
                            <img
                              :src="notRecommendListIcon"
                              class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                              :alt="notRecommendIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else style="margin-right: 0px">
                            <img
                              :src="recommendListIcon"
                              class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                              :alt="recommendIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>{{ item.IsRecommend }}</p>
                        </div>
                      </div>
                      <div
                        v-if="item.IsProductSuppliedFree && showFreeProduct"
                        class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                      >
                        <p>{{ isProductFreeDisplayText }}</p>
                      </div>
                      <div
                        class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                      ></div>
                      <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                        <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                          <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                            <span>{{ helpfulLabel }}</span>
                          </p>
                        </template>
                        <div
                          class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                        >
                          <template v-if="showFavorableReviewSection">
                            <p
                              v-if="item.IsHelpfulCookie == 'no'"
                              @click="defaultUpdateHelpfulReview(item.RRID)"
                            >
                              <img
                                :src="helpfullIcon"
                                class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                                :alt="helpfullIconAltText"
                                loading="lazy"
                              />
                            </p>
                            <p v-else>
                              <img
                                :src="helpfullIcon"
                                class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                                :alt="helpfullIconAltText"
                                loading="lazy"
                              />
                            </p>
                            <p>
                              <span class="rfp-rr-most-ratings-list-123-or bold">{{
                                item.HelpfulCount
                              }}</span>
                            </p>
                          </template>
                          <template v-if="showCriticalReviewSection">
                            <p
                              v-if="item.IsHelpfulCookie == 'no'"
                              @click="defaultUpdateNotHelpfulReview(item.RRID)"
                            >
                              <img
                                :src="nonHelpfullIcon"
                                class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                                :alt="nonHelpfullIconAltText"
                                loading="lazy"
                              />
                            </p>
                            <p v-else>
                              <img
                                :src="nonHelpfullIcon"
                                class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                :alt="nonHelpfullIconAltText"
                                loading="lazy"
                              />
                            </p>
                            <p>
                              <span class="rfp-rr-most-ratings-list-126-or bold">{{
                                item.NotHelpfulCount
                              }}</span>
                            </p>
                          </template>
                          <p>
                            <a
                              v-if="item.IsReported == 'Report'"
                              class="rfp-rr-most-ratings-list-127-or aReported"
                              @click="ratingSummary(item.RRID)"
                              >{{ reportText }}</a
                            >
                            <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                              reportedText
                            }}</a>
                          </p>
                          <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                            <rfp-ratings-social-share
                              :url="currentPageUrl"
                              :title="item.ProductName"
                              :description="item.ReviewContent"
                              :quote="item.ReviewTitle"
                              :facebooks="facebookCaption"
                              :show-fb-media-texts="shareDisplayConfig"
                              :facebook-icons="facebookIcon"
                              :facebook-icon-alt="facebookIconAlt"
                            >
                              <social-sharing-network network="facebook">
                                <p v-if="facebookIcons == ''">
                                  <span
                                    v-if="
                                      showFbMediaTexts == 'Icon and Text' ||
                                      showFbMediaTexts == 'Icon'
                                    "
                                    class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                                  ></span>
                                </p>
                                <p v-else>
                                  <img
                                    v-if="
                                      (facebookIcons != '' &&
                                        showFbMediaTexts == 'Icon and Text') ||
                                      showFbMediaTexts == 'Icon'
                                    "
                                    :src="facebookIcons"
                                    :title="facebookIconAlt"
                                    class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                    :alt="facebookIconAlt"
                                    loading="lazy"
                                  />
                                </p>
                                <span
                                  v-if="
                                    showFbMediaTexts == 'Icon and Text' ||
                                    showFbMediaTexts == 'Text'
                                  "
                                  >{{ facebooks }}</span
                                >
                              </social-sharing-network>
                            </rfp-ratings-social-share>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rfp-comon-space-declaration"></div>
                </div>
                <div
                  v-else
                  :key="`norecord-${itemIndex}`"
                  class="rfp-rr-most-ratings-list-129-or no_record__found"
                >
                  {{ noRecordFound }}
                </div>
              </template>
            </paginate>
          </div>
          <div v-if="!noDataFound" class="rfp-rr-most-ratings-list-130-or rr-table-footer">
            <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
            <span
              v-if="
                items.length > reviewPaginationCount &&
                items.length > toPages * reviewPaginationCount
              "
              class="rfp-rr-most-ratings-list-052-or"
            >
              {{ toPages }}
            </span>
            <span v-else class="rfp-rr-most-ratings-list-053">
              <span v-if="totalNoOfApprovedReviewsPagiantions === currentPageNo">{{
                totalNoOfApprovedReviews
              }}</span>
              <span v-else>{{ currentPageNo * reviewPaginationCount }}</span>
            </span>
            <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
            <div class="rfp-rr-most-ratings-list-132-or rr-table-footer-right float-right">
              <div id="navcontainer">
                <rfp-ratings-pagination-links
                  :page-count="totalNoOfApprovedReviewsPagiantions"
                  :click-handler="defaultPaginationCalculation"
                  :prev-text="paginationPrevious"
                  :next-text="paginationNext"
                  :container-class="'paginate-links items paginate-ul'"
                  active-class="number active paginate-li"
                >
                </rfp-ratings-pagination-links>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <template v-if="items.length === 0">
            <rfp-ratings-slide>
              <div class="rfp-rr-most-ratings-list-129-or no_record__found">
                {{ noRecordFound }}
              </div>
            </rfp-ratings-slide>
          </template>
          <template v-if="items.length != 0">
            <template v-for="(commentIndex, indexCommentsToShow) in commentsToShow">
              <div v-if="commentIndex < items.length + 1" :key="indexCommentsToShow">
                <div
                  v-if="items[commentIndex - 1].NickName != ''"
                  class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
                >
                  <div
                    v-if="
                      showHideLocation || showLabelNickname || userTypeShowHide || showHideAgeRange
                    "
                    class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left"
                  >
                    <p
                      class="rfp-rr-most-ratings-list-099-or rr-user-name"
                      itemprop="author"
                      itemscope
                      itemtype="https://schema.org/Person"
                      :class="{ 'label-hide-show': !showLabelNickname }"
                    >
                      <span class="black bold" itemprop="name">{{
                        items[commentIndex - 1].NickName
                      }}</span>
                    </p>
                    <p
                      v-if="showHideLocation"
                      class="rfp-rr-most-ratings-list-100-or rr-user-location"
                    >
                      <span>{{ items[commentIndex - 1].Location }}</span>
                    </p>
                    <p
                      v-if="userTypeShowHide && items[commentIndex - 1].UserType != null"
                      class="rfp-rr-most-ratings-list-133-or rr-user-name"
                    >
                      {{ userTypeDesc }} :<span> {{ items[commentIndex - 1].UserType }}</span>
                    </p>
                    <p
                      v-if="items[commentIndex - 1].AgeRange && showHideAgeRange"
                      class="rfp-rr-most-ratings-list-102-or rr-user-age"
                    >
                      {{ ageLabel }} :
                      <span class="bold"> {{ items[commentIndex - 1].AgeRange }}</span>
                    </p>
                  </div>
                  <div
                    class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right"
                    :class="{
                      'rfp-rare-full-width-conntainer':
                        !showHideLocation &&
                        !showLabelNickname &&
                        !userTypeShowHide &&
                        !showHideAgeRange,
                    }"
                  >
                    <span
                      class="rfp-rr-most-ratings-list-104-or review-stars"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <vue-star-rating
                        :increment="starRatingIncrementValue"
                        :max-rating="starRatingMaxRatingValue"
                        :inactive-color="starRatingInactiveColor"
                        :active-color="starRatingActiveColor"
                        :star-size="starRatingStarSize"
                        :rating="items[commentIndex - 1].OverallRating"
                        :read-only="true"
                        :show-rating="false"
                      >
                      </vue-star-rating>
                    </span>
                    <span
                      v-if="showCreatedAt"
                      class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >- {{ items[commentIndex - 1].CreatedDate }}</span
                    >
                    <div
                      class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                    ></div>
                    <h3
                      v-if="showHideReviewTitle"
                      class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                    >
                      {{ items[commentIndex - 1].ReviewTitle }}
                    </h3>
                    <p
                      v-if="showHideReviewContent"
                      class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      v-html="items[commentIndex - 1].ReviewContent"
                    ></p>
                    <rfp-ratings-list-images
                      v-if="hasImages(items[commentIndex - 1])"
                      :data="items[commentIndex - 1].Images"
                      @openedmodal="(e) => openModal(e, items[commentIndex - 1].Images)"
                    >
                    </rfp-ratings-list-images>
                    <div
                      v-if="showHideQualityRating"
                      class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                      :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                    >
                      <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">
                        {{ qualityOfProductLabel }}
                      </span>
                      <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer">
                        <span
                          class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                          :style="{ width: items[commentIndex - 1].QualityRating * 20 + '%' }"
                        >
                        </span
                      ></span>
                      <span class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold">
                        {{ items[commentIndex - 1].QualityRating }}
                      </span>
                    </div>
                    <div
                      v-if="showHideIsProductRecommended"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <div
                        class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                        itemprop="reviewBody"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <p
                          v-if="!items[commentIndex - 1].IsProductRecommended"
                          style="margin-right: 0px"
                        >
                          <img
                            :src="notRecommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="notRecommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else style="margin-right: 0px">
                          <img
                            :src="recommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="recommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>{{ items[commentIndex - 1].IsRecommend }}</p>
                      </div>
                    </div>

                    <div
                      v-if="items[commentIndex - 1].IsProductSuppliedFree && showFreeProduct"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <p>{{ isProductFreeDisplayText }}</p>
                    </div>
                    <div
                      class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                    ></div>
                    <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                      <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                        <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                          <span>{{ helpfulLabel }}</span>
                        </p>
                      </template>
                      <div
                        class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <template v-if="showFavorableReviewSection">
                          <p
                            v-if="items[commentIndex - 1].IsHelpfulCookie == 'no'"
                            @click="UpdateHelpfulReview(items[commentIndex - 1].RRID)"
                          >
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-123-or bold">{{
                              items[commentIndex - 1].HelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <template v-if="showCriticalReviewSection">
                          <p
                            v-if="items[commentIndex - 1].IsHelpfulCookie == 'no'"
                            @click="UpdateNotHelpfulReview(items[commentIndex - 1].RRID)"
                          >
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-126-or bold">{{
                              items[commentIndex - 1].NotHelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <p>
                          <a
                            v-if="items[commentIndex - 1].IsReported == 'Report'"
                            class="rfp-rr-most-ratings-list-127-or aReported"
                            @click="ratingSummary(items[commentIndex - 1].RRID)"
                            >{{ reportText }}</a
                          >
                          <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                            reportedText
                          }}</a>
                        </p>
                        <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                          <rfp-ratings-social-share
                            :url="currentPageUrl"
                            :title="items[commentIndex - 1].ProductName"
                            :description="items[commentIndex - 1].ReviewContent"
                            :quote="items[commentIndex - 1].ReviewTitle"
                            :facebooks="facebookCaption"
                            :show-fb-media-texts="shareDisplayConfig"
                            :facebook-icons="facebookIcon"
                            :facebook-icon-alt="facebookIconAlt"
                          >
                            <social-sharing-network network="facebook">
                              <p v-if="facebookIcons == ''">
                                <span
                                  v-if="
                                    showFbMediaTexts == 'Icon and Text' ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                                ></span>
                              </p>
                              <p v-else>
                                <img
                                  v-if="
                                    (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  :title="facebookIconAlt"
                                  :src="facebookIcons"
                                  class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                  :alt="facebookIconAlt"
                                  loading="lazy"
                                />
                              </p>
                              <span
                                v-if="
                                  showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'
                                "
                                >{{ facebooks }}</span
                              >
                            </social-sharing-network>
                          </rfp-ratings-social-share>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="rfp-rr-most-ratings-list-129-or no_record__found">
                  {{ noRecordFound }}
                </div>
                <div class="rfp-comon-space-declaration"></div>
              </div>
            </template>
            <button
              v-if="commentsToShow < totalNoOfApprovedReviews"
              class="rfp-ratings-load-more"
              @click="loadMoreHeaddercount"
            >
              <span>{{ showMoreText }}</span>
            </button>
          </template>
        </div>
      </div>
      <div v-else>
        <template v-if="items.length === 0">
          <rfp-ratings-slide>
            <div class="rfp-rr-most-ratings-list-129-or no_record__found">
              {{ noRecordFound }}
            </div>
          </rfp-ratings-slide>
        </template>
        <template v-if="items.length != 0">
          <rfp-ratings-carousel
            :autoplay="false"
            :autoplay-timeout="10000"
            :loop="false"
            :autoplay-hover-pause="true"
            :min-swipe-distance="8"
            pagination-active-color="#f30606"
            pagination-color="#efefef"
            :pagination-padding="10"
            :pagination-size="10"
            :per-page="1"
            :navigation-enabled="true"
            :pagination-enabled="false"
          >
            <template v-for="(item, index) in items">
              <rfp-ratings-slide v-if="item.NickName" :key="index">
                <div
                  class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
                >
                  <div
                    v-if="
                      showHideLocation || showLabelNickname || userTypeShowHide || showHideAgeRange
                    "
                    class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left-carousel"
                  >
                    <p
                      class="rfp-rr-most-ratings-list-099-or rr-user-name"
                      itemprop="author"
                      itemscope
                      itemtype="https://schema.org/Person"
                      :class="{ 'label-hide-show': !showLabelNickname }"
                    >
                      <span class="black bold" itemprop="name">{{ item.NickName }}</span>
                    </p>
                    <p
                      v-if="showHideLocation"
                      class="rfp-rr-most-ratings-list-100-or rr-user-location"
                    >
                      <span>{{ item.Location }}</span>
                    </p>
                    <p
                      v-if="userTypeShowHide && item.UserType != null"
                      class="rfp-rr-most-ratings-list-133-or rr-user-name"
                    >
                      {{ userTypeDesc }} :<span> {{ item.UserType }}</span>
                    </p>
                    <p
                      v-if="item.AgeRange && showHideAgeRange"
                      class="rfp-rr-most-ratings-list-102-or rr-user-age"
                    >
                      {{ ageLabel }} : <span class="bold"> {{ item.AgeRange }}</span>
                    </p>
                  </div>
                  <div
                    class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right-carousel"
                    :class="{
                      'rfp-rare-full-width-conntainer':
                        !showHideLocation &&
                        !showLabelNickname &&
                        !userTypeShowHide &&
                        !showHideAgeRange,
                    }"
                  >
                    <span
                      class="rfp-rr-most-ratings-list-104-or review-stars"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <vue-star-rating
                        :increment="starRatingIncrementValue"
                        :max-rating="starRatingMaxRatingValue"
                        :inactive-color="starRatingInactiveColor"
                        :active-color="starRatingActiveColor"
                        :star-size="starRatingStarSize"
                        :rating="item.OverallRating"
                        :read-only="true"
                        :show-rating="false"
                      >
                      </vue-star-rating>
                    </span>
                    <span
                      v-if="showCreatedAt"
                      class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >- {{ item.CreatedDate }}</span
                    >
                    <div
                      class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                    ></div>
                    <h3
                      v-if="showHideReviewTitle"
                      class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                    >
                      {{ item.ReviewTitle }}
                    </h3>
                    <p
                      v-if="showHideReviewContent"
                      class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      v-html="item.ReviewContent"
                    ></p>
                    <rfp-ratings-list-images
                      v-if="hasImages(item)"
                      :data="item.Images"
                      @openedmodal="(e) => openModal(e, item.Images)"
                    >
                    </rfp-ratings-list-images>
                    <div
                      v-if="showHideQualityRating"
                      class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                      :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                    >
                      <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">{{
                        qualityOfProductLabel
                      }}</span>
                      <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer"
                        ><span
                          class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                          :style="{ width: item.QualityRating * 20 + '%' }"
                        ></span
                      ></span>
                      <span
                        class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold"
                        >{{ item.QualityRating }}</span
                      >
                    </div>
                    <div
                      v-if="showHideIsProductRecommended"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <div
                        class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                        itemprop="reviewBody"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <p v-if="!item.IsProductRecommended" style="margin-right: 0px">
                          <img
                            :src="notRecommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="notRecommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else style="margin-right: 0px">
                          <img
                            :src="recommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="recommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>{{ item.IsRecommend }}</p>
                      </div>
                    </div>

                    <div
                      v-if="item.IsProductSuppliedFree && showFreeProduct"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <p>{{ isProductFreeDisplayText }}</p>
                    </div>
                    <div
                      class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                    ></div>
                    <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                      <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                        <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                          <span>{{ helpfulLabel }}</span>
                        </p>
                      </template>
                      <div
                        class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <template v-if="showFavorableReviewSection">
                          <p
                            v-if="item.IsHelpfulCookie == 'no'"
                            @click="UpdateHelpfulReview(item.RRID)"
                          >
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-123-or bold">{{
                              item.HelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <template v-if="showCriticalReviewSection">
                          <p
                            v-if="item.IsHelpfulCookie == 'no'"
                            @click="UpdateNotHelpfulReview(item.RRID)"
                          >
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-126-or bold">{{
                              item.NotHelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <p>
                          <a
                            v-if="item.IsReported == 'Report'"
                            class="rfp-rr-most-ratings-list-127-or aReported"
                            @click="ratingSummary(item.RRID)"
                            >{{ reportText }}</a
                          >
                          <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                            reportedText
                          }}</a>
                        </p>
                        <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                          <rfp-ratings-social-share
                            :url="currentPageUrl"
                            :title="item.ProductName"
                            :description="item.ReviewContent"
                            :quote="item.ReviewTitle"
                            :facebooks="facebookCaption"
                            :show-fb-media-texts="shareDisplayConfig"
                            :facebook-icons="facebookIcon"
                            :facebook-icon-alt="facebookIconAlt"
                          >
                            <social-sharing-network network="facebook">
                              <p v-if="facebookIcons == ''">
                                <span
                                  v-if="
                                    showFbMediaTexts == 'Icon and Text' ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                                ></span>
                              </p>
                              <p v-else>
                                <img
                                  v-if="
                                    (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  :title="facebookIconAlt"
                                  :src="facebookIcons"
                                  class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                  :alt="facebookIconAlt"
                                  loading="lazy"
                                />
                              </p>
                              <span
                                v-if="
                                  showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'
                                "
                                >{{ facebooks }}</span
                              >
                            </social-sharing-network>
                          </rfp-ratings-social-share>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </rfp-ratings-slide>
            </template>
          </rfp-ratings-carousel>
        </template>
      </div>
    </div>
    <div v-if="enableModal">
      <rfp-ratings-list-carousel-modal
        :images="carouselConfig.modalImages"
        :main-position="carouselConfig.mainPosition"
        :visible="carouselConfig.showModal"
        :show-actions="carouselConfig.showActions"
        :show-thumbnails="carouselConfig.showThumbnails"
        @closedmodal="closeModal"
      >
      </rfp-ratings-list-carousel-modal>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import VueStarRating from 'vue-star-rating';
import RfpRatingsSocialShare from '@/components/widget/rfp-ratings-social-share/Plugins/rfp-ratings-social-share.vue';
import SocialSharingNetwork from '@/components/widget/rfp-ratings-social-share/Plugins/social-sharing-network.js';
import axios from 'axios';
import datalayerMixin from '@/lib/datalayer-mixin';
import RfpRatingsListImages from './rfp-ratings-list-images/rfp-ratings-list-images.vue';
import RfpRatingsListCarouselModal from './rfp-ratings-list-carousel-modal/rfp-ratings-list-carousel-modal.vue';
import RfpRatingsCarousel from '@/components/widget/rfp-ratings-slider/rfp-ratings-carousel.vue';
import RfpRatingsSlide from '@/components/widget/rfp-ratings-slider/rfp-ratings-slide.vue';
import RfpRatingsPaginationLinks from '@/components/widget/rfp-ratings-pagination-links/rfp-ratings-pagination-links.vue';

export default {
  name: 'rfp-ratings-list',
  components: {
    VueStarRating,
    RfpRatingsSocialShare,
    SocialSharingNetwork,
    RfpRatingsSlide,
    RfpRatingsListImages,
    RfpRatingsCarousel,
    RfpRatingsListCarouselModal,
    RfpRatingsPaginationLinks,
  },
  mixins: [datalayerMixin('rfp-ratings-list')],
  props: {
    enableModal: {
      type: Boolean,
      required: false,
      default: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    supportContent: {
      type: String,
      required: false,
    },
    sortDisplayDatas: {
      type: String,
      required: true,
    },
    sortList: {
      type: Array,
      required: true,
    },
    oneStarText: {
      type: String,
      required: true,
    },
    twoStarText: {
      type: String,
      required: true,
    },
    threeStarText: {
      type: String,
      required: true,
    },
    fourStarText: {
      type: String,
      required: true,
    },
    fiveStarText: {
      type: String,
      required: true,
    },
    activeFilters: {
      type: String,
      required: true,
    },
    clearAll: {
      type: String,
      required: true,
    },
    qualityOfProductLabel: {
      type: String,
      required: true,
    },
    ageLabel: {
      type: String,
      required: true,
    },
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: true,
    },
    reported: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    baseUrlsFetchReviewDetails: {
      type: String,
      required: true,
    },
    reviewPaginationCount: {
      type: Number,
      required: true,
    },
    reviewPaginataionText: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReview: {
      type: String,
      required: true,
    },
    noRecordFound: {
      type: String,
      required: true,
    },
    helpfullIcon: {
      type: String,
      required: true,
    },
    nonHelpfullIcon: {
      type: String,
      required: true,
    },
    helpfullIconAltText: {
      type: String,
      required: true,
    },
    nonHelpfullIconAltText: {
      type: String,
      required: true,
    },
    recommendIconAltText: {
      type: String,
      required: true,
    },
    recommendListIcon: {
      type: String,
      required: true,
    },
    notRecommendIconAltText: {
      type: String,
      required: true,
    },
    notRecommendListIcon: {
      type: String,
      required: true,
    },
    userTypeShowHide: {
      type: Boolean,
      required: true,
    },
    userTypeDesc: {
      type: String,
      required: true,
    },
    paginationShowing: {
      type: String,
      required: true,
    },
    paginationOutof: {
      type: String,
      required: true,
    },
    addIcon: {
      type: String,
      required: true,
    },
    filterEnable: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    ratingsListOption: {
      type: String,
      required: false,
    },
    showMoreText: {
      type: String,
      default: 'Show More',
    },
    paginationNext: {
      type: String,
      required: false,
    },
    paginationPrevious: {
      type: String,
      required: false,
    },
    facebookCaption: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showHideLocation: {
      type: Boolean,
      default: true,
    },
    showHideAgeRange: {
      type: Boolean,
      default: true,
    },
    showHideReviewTitle: {
      type: Boolean,
      default: true,
    },
    showCreatedAt: {
      type: Boolean,
      default: true,
    },
    showHideReviewContent: {
      type: Boolean,
      default: true,
    },
    showHideQualityRating: {
      type: Boolean,
      default: true,
    },
    showHideIsProductRecommended: {
      type: Boolean,
      default: true,
    },
    showLabelNickname: {
      type: Boolean,
      default: false,
    },
    showFavorableReviewSection: {
      type: Boolean,
      default: true,
    },
    showCriticalReviewSection: {
      type: Boolean,
      default: true,
    },
    isProductFreeDisplayText: {
      type: String,
      required: false,
    },
    showFreeProduct: {
      type: String,
      required: false,
    },
    sortReviewTags: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      items: [],
      paginate: ['items'],
      carouselConfig: {
        modalImages: [],
        mainPosition: 0,
        showModal: false,
        showActions: true,
        showThumbnails: true,
      },
      stars: {
        oneStar: false,
        twoStar: false,
        threeStar: false,
        fourStar: false,
        fiveStar: false,
      },
      sort: {
        hlr: false,
        lhr: false,
        mh: false,
        mr: false,
      },
      filterDiv: false,
      upHere: false,
      helpfulLabels: this.helpfulLabel,
      reports: this.report,
      reporteds: this.reported,
      reportDisplayed: false,
      sortDisplayData: this.sortDisplayDatas,
      sortDisplayDatamobileView: this.sortDisplayDatas,
      noDataFound: false,
      toPages: 1,
      supportContentEnable: false,
      filterSortEnable: false,
      commentsToShow: this.reviewPaginationCount,
      currentPaginationPage: 0,
      rfpFilterOne: false,
      rfpFilterTwo: false,
      rfpFilterThree: false,
      rfpFilterFour: false,
      rfpFilterFive: false,
      currentPageNo: 1,
      totalNoOfApprovedReviews: 0,
      normalPagination: [],
      itemsDefault: [],
      maxPageLength: 1,
      totalNoOfApprovedReviewsPagiantions: 0,
      currentPageUrl: window.location.href,
      filterCounts: 0,
      sortDataCount: 0,
      readReviewTriggered: false,
    };
  },
  updated() {
    if (
      !this.readReviewTriggered &&
      this.items &&
      this.items.length > 0 &&
      document.querySelector('.rr-user-review-comment') != null
    ) {
      this.onElementVisible(document.querySelector('.rr-user-review-comment'), () => {
        if (!this.readReviewTriggered) {
          eventBus.emit('readReviewTags');
          this.readReviewTriggered = true;
        }
      });
    }
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('reviewDatas', (value) => {
      if (value[0] === undefined) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
        if (this.ratingsListOption === '') {
          this.items = value;
          const obj = {};
          obj['pages' + this.currentPageNo] = value;
          this.itemsDefault.push(obj);
        } else {
          this.items.push(...value);
        }
      }
    });
    /* istanbul ignore next */
    eventBus.on('FilterstarLabel', () => {
      this.filterCounts = 2;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = true;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('rfp-global-page-change', (value) => {
      this.currentPaginationPage = value;
    });
    /* istanbul ignore next */
    eventBus.on('oneTwoThree', () => {
      this.filterCounts = 3;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = true;
      this.stars.twoStar = true;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterOne', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = true;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterTwo', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = false;
      this.stars.twoStar = true;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterThree', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterFour', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = false;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterFive', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = true;
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('dataGetFromDB', (val) => {
      const calculation = this.currentPageNo + 1;
      const calculateCondition = val + 2;
      if (calculateCondition > this.items.length) {
        this.currentPageNo = calculation;
        this.fetchReviewDetails();
      }
    });

    this.fetchReviewDetails();
  },
  mounted() {
    let listPageEl = document.getElementById('rare-list-page');
    if (listPageEl) {
      this.onElementVisible(listPageEl, () => {
        this.canLoadReviews = true;
        this.fetchReviewDetails();
      });
    }
  },
  methods: {
    openModal(e, data) {
      this.carouselConfig.mainPosition = e;
      this.carouselConfig.modalImages = data;
      this.carouselConfig.showModal = true;
    },
    closeModal() {
      this.carouselConfig.showModal = false;
    },
    hasImages(item) {
      return item?.Images?.length;
    },
    onElementVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
    },
    fetchReviewDetails() {
      const starFilterOne = this.stars.oneStar ? '&filterData=1' : '';
      const starFilterTwo = this.stars.twoStar ? '&filterData=2' : '';
      const starFilterThree = this.stars.threeStar ? '&filterData=3' : '';
      const starFilterFour = this.stars.fourStar ? '&filterData=4' : '';
      const starFilterFive = this.stars.fiveStar ? '&filterData=5' : '';

      const sorthlr = this.sort.hlr ? '&sortData=hlr' : '';
      const sortlhr = this.sort.lhr ? '&sortData=lhr' : '';
      const sortmh = this.sort.mh ? '&sortData=mh' : '';
      const sortmr = this.sort.mr ? '&sortData=mr' : '';
      if (this.canLoadReviews) {
        /* istanbul ignore next */
        axios
          .get(
            this.baseUrlsFetchReviewDetails +
              '?languageCode=' +
              this.languageCode +
              '&productID=' +
              this.productId +
              '&page=' +
              this.currentPageNo +
              '&pageSize=' +
              this.reviewPaginationCount +
              '' +
              starFilterOne +
              '' +
              starFilterTwo +
              '' +
              starFilterThree +
              '' +
              starFilterFour +
              '' +
              starFilterFive +
              '' +
              sorthlr +
              '' +
              sortlhr +
              '' +
              sortmh +
              '' +
              sortmr,
            { headers: { Pragma: 'no-cache' } },
          )
          .then((response) => {
            if (this.ratingsListOption === '') {
              const totalNoOfApprovedReviewsCalculate = response.data.TotalNoOfApprovedReviews;
              const x = totalNoOfApprovedReviewsCalculate / this.reviewPaginationCount;
              const decimals = x - Math.floor(x);
              this.totalNoOfApprovedReviews = response.data.TotalNoOfApprovedReviews;
              if (decimals.toFixed(1) === '0.0') {
                this.totalNoOfApprovedReviewsPagiantions = x;
              } else if (x === 1) {
                this.totalNoOfApprovedReviewsPagiantions = ~~x;
              } else {
                this.totalNoOfApprovedReviewsPagiantions = ~~x + 1;
              }
            } else {
              this.totalNoOfApprovedReviews = response.data.TotalNoOfApprovedReviews;
            }

            eventBus.emit('reviewDatas', response.data.ProductReviews);
            eventBus.emit('reviewDatasLength', response.data.TotalNoOfApprovedReviews);
          });
      }
    },
    defaultPaginationCalculation(pageNum) {
      this.currentPageNo = pageNum;
      const hardCodeValue = 'pages' + pageNum;
      /* istanbul ignore next */
      const foundValue = this.itemsDefault.filter((obj) => obj[hardCodeValue]);

      if (foundValue.length === 0) {
        this.currentPageNo = pageNum;
        this.maxPageLength = pageNum;
        this.fetchReviewDetails();
      } else {
        /* istanbul ignore next */
        this.items = foundValue[0][hardCodeValue];
      }
      /* istanbul ignore next */
      // this.$scrollTo('#rare-list-page');
    },
    onLangsPageChange(toPage) {
      this.toPages = toPage;
      /* istanbul ignore next */
      // this.$scrollTo('#rare-list-page');
    },
    loadMoreHeaddercount() {
      this.commentsToShow += this.reviewPaginationCount;
      this.toPages = this.toPages + 1;
      this.currentPageNo = this.toPages;
      this.fetchReviewDetails();
    },
    dataLayerTagging(tags) {
      if (!tags) return false;
      eventBus.emit(this.getTaggingEventName(), JSON.parse(tags));
    },
    supportContentEnableFunction() {
      this.filterSortEnable = false;
      if (this.supportContentEnable) {
        /* istanbul ignore next */
        this.supportContentEnable = false;
      } else {
        this.supportContentEnable = true;
      }
    },
    filterSortEnableFunction() {
      this.supportContentEnable = false;
      /* istanbul ignore next */
      if (this.filterSortEnable) {
        this.filterSortEnable = false;
      } else {
        this.filterSortEnable = true;
      }
    },
    sortReviews(direction, displayDatas) {
      this.dataLayerTagging(this.sortReviewTags);
      if (this.sortDataCount === 0) {
        this.sortDataCount = 1;
        this.filterCounts = this.filterCounts + 1;
      }
      /* istanbul ignore next */
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      eventBus.emit('sortReviewsTags', displayDatas);
      this.filterSortEnable = false;
      this.sortDisplayData = displayDatas;
      this.sortDisplayDatamobileView = direction;

      // TODO: Define what hlr, lhr, mh, mr mean
      const base = {
        hlr: false,
        lhr: false,
        mh: false,
        mr: false,
      };

      if (!Object.keys(base).includes(direction))
        throw new Error('error/rfp-ratings-list#sortData');

      this.sort = {
        ...base,
        [direction]: true,
      };

      this.currentPageNo = 1;
      this.fetchReviewDetails();
    },

    filterByStars(rank) {
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }

      const filterIdentifier = `rfpFilter${rank[0].toUpperCase()}${rank.slice(1)}`;
      const starIdentifier = `${rank}Star`;
      this.stars[starIdentifier] = !this.stars[starIdentifier];
      this[filterIdentifier] = !this[filterIdentifier];

      if (this.stars[`${rank}Star`]) {
        --this.filterCounts;
      } else {
        ++this.filterCounts;
        eventBus.emit('filter-action-triggered', this[`${rank}StarText`]);
      }

      this.currentPageNo = 1;
      this.fetchReviewDetails();
    },

    clearAllStars() {
      const filterKeys = [
        'rfpFilterOne',
        'rfpFilterTwo',
        'rfpFilterThree',
        'rfpFilterFour',
        'rfpFilterFive',
      ];
      Object.keys(this.stars).forEach((key) => (this.stars[key] = false));
      Object.keys(this.sort).forEach((key) => (this.sort[key] = false));
      filterKeys.forEach((key) => (this[key] = false));

      this.sortDataCount = 0;
      this.filterCounts = 0;
      this.sortDisplayData = this.sortDisplayDatas;
      this.sortDisplayDatamobileView = this.sortDisplayDatas;
      this.currentPageNo = 1;
      if (this.ratingsListOption === 'Ratings load more') {
        this.items = [];
        this.commentsToShow = this.reviewPaginationCount;
        this.toPages = 1;
      }
      this.fetchReviewDetails();
    },
    hamburger() {
      this.filterSortEnable = false;
      this.supportContentEnable = false;
      if (this.filterDiv === true) {
        this.filterDiv = false;
      } else {
        this.filterDiv = true;
      }
    },
    mouseOver() {
      this.active = !this.active;
    },

    ratingSummary(val) {
      const reportedCookie = 'reportedCookie' + val;
      /* istanbul ignore next */
      axios
        .get(this.reportReviewApi + '?rrID=' + val + '', { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message === 'Reported') {
            this.fetchReviewDetails();
          }
        });
    },
    findObjectByKeyUpdate(array, key, value) {
      /* istanbul ignore next */
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          const mykey = 'IsHelpfulCookie';
          const HelpfulCount = 'HelpfulCount';
          array[i][mykey] = 'yes';
          // eslint-disable-next-line
          array[i][HelpfulCount] = array[i][HelpfulCount] + 1;
        }
      }
      return null;
    },
    findObjectByKeyNotUpdate(array, key, value) {
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          const mykey = 'IsHelpfulCookie';
          const HelpfulCount = 'NotHelpfulCount';
          array[i][mykey] = 'yes';
          // eslint-disable-next-line
          array[i][HelpfulCount] = array[i][HelpfulCount] + 1;
        }
      }
      return null;
    },
    UpdateHelpfulReview(val) {
      eventBus.emit('LikeReviewTags');
      const reportedCookie = 'reportedCookie' + val;
      /* istanbul ignore next */
      axios
        .get(this.updateHelpfulReviewApi + '?rrID=' + val, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message === 'Success') {
            this.findObjectByKeyUpdate(this.items, 'RRID', val);
          }
        });
    },
    UpdateNotHelpfulReview(val) {
      eventBus.emit('unLikeReviewTags');
      const reportedCookie = 'reportedCookie' + val;
      /* istanbul ignore next */
      axios
        .get(this.updateNotHelpfulReview + '?rrID=' + val, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message === 'Success') {
            this.findObjectByKeyNotUpdate(this.items, 'RRID', val);
          }
        });
    },
    defaultUpdateHelpfulReview(val) {
      eventBus.emit('LikeReviewTags');
      const reportedCookie = 'reportedCookie' + val;
      /* istanbul ignore next */
      axios
        .get(this.updateHelpfulReviewApi + '?rrID=' + val, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message === 'Success') {
            const hardCodeValue = 'pages' + this.currentPageNo;
            const foundValue = this.itemsDefault.filter((obj) => obj[hardCodeValue]);
            this.findObjectByKeyUpdate(this.items, 'RRID', val);
          }
        });
    },
    defaultUpdateNotHelpfulReview(val) {
      eventBus.emit('unLikeReviewTags');
      const reportedCookie = 'reportedCookie' + val;
      /* istanbul ignore next */
      axios
        .get(this.updateNotHelpfulReview + '?rrID=' + val, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message === 'Success') {
            const hardCodeValue = 'pages' + this.currentPageNo;
            const foundValue = this.itemsDefault.filter((obj) => obj[hardCodeValue]);
            this.findObjectByKeyNotUpdate(this.items, 'RRID', val);
          }
        });
    },
  },
};
</script>
